import NavBar from "../../components/NavBar";
import { Container, MainContent } from "./style";

const Contact = () => {

    return (
        <Container>
            <NavBar />

            <MainContent>

            </MainContent >

        </Container>
    )
}

export default Contact;


